// extracted by mini-css-extract-plugin
export default {"button":"EventV2_button__tzAq8","buttonWrapper":"EventV2_buttonWrapper__G-gYy"};